// @flow
import React, { Component } from 'react';
import type { Node } from 'react';
import Viewer from '../../src';
import ListingWidget from './listing-widget';
import CheckboxWidget from './checkbox-widget';

import type { Listing } from '../../src';

const { localStorage } = window;

type Props = {
  url: string,
};

type State = {
  debug: boolean,
  markers: boolean,
  listings: Array<Listing>,
  listingsWithoutMarkers: Array<Listing>,
  hovered: number,
  favorites: Array<string | number>,
  selected?: string,
};

const styles = {
  widgetContainer: {
    display: 'flex',
    position: 'absolute',
    flexDirection: 'column',
    zIndex: 10,
    left: 50,
    top: 10,
    padding: '3px 5px',
    backgroundColor: 'white',
    boxShadow: 'rgba(0, 0, 0, 0.3) 0px 1px 4px',
    border: '1px solid rgba(0, 0, 0, 0.1)',
  },
  clearSelectedWidget: {
    margin: '2px 0',
  },
  hoveredListingsWidget: {
    paddingLeft: 20,
  },
  viewer: {
    opacity: 1,
  },
};

const getPersistantBool = (key, defaultValue = true) => {
  try {
    const value = localStorage.getItem(`seatcrawler-demo-${key}`);
    if (value !== null) {
      return !!JSON.parse(value);
    }
  } catch (err) {
    // ignore
  }

  return defaultValue;
};

const togglePersistantBool = (context: Component<Props, State>, key: string) => () => {
  context.setState((prevState) => {
    const value = !prevState[key];

    try {
      localStorage.setItem(`seatcrawler-demo-${key}`, JSON.stringify(value));
    } catch (err) {
      // ignore
    }

    return { [key]: value };
  });
};

class Demo extends Component<Props, State> {
  constructor(...args: any) {
    super(...args);

    this.state = {
      debug: getPersistantBool('debug'),
      markers: getPersistantBool('markers'),
      listings: [],
      listingsWithoutMarkers: [],
      favorites: [],
      selected: undefined,
      hovered: 0,
    };
  }

  get clearSelectedWidget(): Node {
    if (!this.state.selected) return null;

    return (
      <button
        onClick={this.updateSelected}
        style={styles.clearSelectedWidget}
      >
        Clear selected
      </button>
    );
  }

  get listingsOnlyWidgets(): Node {
    if (!this.state.listings.length) return null;

    return (
      <div>
        <CheckboxWidget
          label="Include listing markers"
          value={this.state.markers}
          onChange={this.toggleMarkers}
        />
        <div style={styles.hoveredListingsWidget}>
          Hovered listings: {this.state.hovered}
        </div>
      </div>
    );
  }

  toggleDebug = togglePersistantBool(this, 'debug');
  toggleMarkers = togglePersistantBool(this, 'markers');

  updateListings = (listings: Array<Listing>) => {
    const favorites = listings
      .filter(() => Math.random() < 0.3)
      .map(({ id }) => id);

    const listingsWithoutMarkers = listings.map(listing => ({
      ...listing,
      quality: undefined,
    }));

    this.setState({ listings, listingsWithoutMarkers, favorites });
  };

  updateHovered = (listings: Array<Listing>) => {
    this.setState({ hovered: listings.length });
  };

  updateSelected = (listing: any) => {
    this.setState({ selected: listing && listing.id });
  }

  render() {
    const listings = this.state.markers
      ? this.state.listings
      : this.state.listingsWithoutMarkers;

    return (
      <div className="mapbox-container">
        <div style={styles.widgetContainer}>
          <ListingWidget
            url={this.props.url}
            onListingsChange={this.updateListings}
          />
          <CheckboxWidget
            label="Show feature properties"
            value={this.state.debug}
            onChange={this.toggleDebug}
          />
          {this.listingsOnlyWidgets}
          {this.clearSelectedWidget}
        </div>
        <Viewer
          className="test-viewer-overrides"
          style={styles.viewer}
          debug={this.state.debug}
          url={this.props.url}
          listings={listings}
          favorites={this.state.favorites}
          selected={this.state.selected}
          onListingClick={this.updateSelected}
          onListingsHover={this.updateHovered}
        />
      </div>
    );
  }
}

export default Demo;



// WEBPACK FOOTER //
// ./demo/src/demo.js